import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Radio } from 'tdesign-react';
import usePerms from '@/hooks/usePerms';

export default function ClusterSwitch() {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const [hasKop, hasPulsar] = usePerms(['kop:cluster', 'pulsar:cluster']);

  // 需同时授权KOP、Plusar 才允许切换，否则不展示
  const canToggle = hasKop && hasPulsar;

  const switchCluster = (toPath) => {
    navigate(toPath);
  };
  return canToggle ? (
    <Radio.Group
      variant='default-filled'
      value={pathname}
      onChange={switchCluster}
      style={{ marginBottom: 20 }}
    >
      <Radio.Button value='/cluster'>Pulsar集群</Radio.Button>
      <Radio.Button value='/kop-cluster'>KOP集群</Radio.Button>
    </Radio.Group>
  ) : null;
}
